import React, { useState, useRef, useEffect } from "react";
import LoadingSpinner from "../layouts/loading.container";
declare const window: any;

interface Spin360Props {
  imageUrls: string[]; // Array de URLs de las imágenes
  isSelectedAmenities: string;
  frame: any;
  setFrame: any;
  subMenuSelected: string;
  menuSelected: string;
  isView: any;
  setIShowAsoleacion: any;
  isShowAsoleacion: any;
  dragStart: any;
  setDragStart: any;
  imageDivs: any;
  setIsLoading: any;
  isLoading: any;
  isSelectedAttribute: any;
  currentSelectedAttribute: any;
  attributesFrame: any;
  attributesValues: any;
}

const movementThreshold = 1; // Umbral de movimiento para considerar el cambio de imagen
const imagesToRotateMultiplier = 0.001; // Multiplicador para ajustar la velocidad del giro

const SpinGeneralContainer: React.FC<Spin360Props> = ({
  imageUrls,
  isSelectedAmenities,
  frame,
  setFrame,
  subMenuSelected,
  menuSelected,
  isView,
  setIShowAsoleacion,
  isShowAsoleacion,
  dragStart,
  setDragStart,
  imageDivs,
  setIsLoading,
  isLoading,
  isSelectedAttribute,
  currentSelectedAttribute,
  attributesFrame,
  attributesValues,
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [smoothedMovementX, setSmoothedMovementX] = useState(0);
  const [changeAmenities, setchangeAmenities] = useState("");
  const [changeAttribute, setchangeAtribute] = useState({});
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [screenHeight, setScreenHeight] = useState(window.innerHeight);
  const [arrImage100, setArrImage100]: any = useState(
    Array.from({ length: 100 }, () => false)
  );
  const [arrImage50, setArrImage50]: any = useState(
    Array.from({ length: 50 }, () => false)
  );
  const [arrImage25, setArrImage25]: any = useState(
    Array.from({ length: 25 }, () => false)
  );

  useEffect(() => {
    if (imageUrls !== undefined && imageUrls !== null && imageUrls.length > 0) {
      setIsLoading(true);
      const X = [0, 4, 2, 8, 1, 3, 6, 5, 9, 7];
      let counter = 0;

      const loadImage = (src: string, value: number): Promise<void> => {
        return new Promise((resolve) => {
          const image = new Image();
          let imageDivsTemp: any =
            menuSelected === "Urbanismo" ||
            (((menuSelected === "Inmuebles" &&
              subMenuSelected !== "Galería" &&
              subMenuSelected !== "") ||
              (menuSelected === "Amenidades" &&
                subMenuSelected !== "Galería" &&
                subMenuSelected !== "")) &&
              imageUrls.length === 50)
              ? arrImage50
              : ((menuSelected === "Inmuebles" &&
                  subMenuSelected !== "Galería" &&
                  subMenuSelected !== "") ||
                  (menuSelected === "Amenidades" &&
                    subMenuSelected !== "Galería" &&
                    subMenuSelected !== "")) &&
                imageUrls.length === 25
              ? arrImage25
              : arrImage100;

          image.src = src;
          image.onload = () => {
            counter++;
            resolve();
            imageDivsTemp[value] = true;
            menuSelected === "Urbanismo" ||
            (((menuSelected === "Inmuebles" &&
              subMenuSelected !== "Galería" &&
              subMenuSelected !== "") ||
              (menuSelected === "Amenidades" &&
                subMenuSelected !== "Galería" &&
                subMenuSelected !== "")) &&
              imageUrls.length === 50)
              ? (setArrImage50([...imageDivsTemp]),
                setArrImage100(Array.from({ length: 100 }, () => false)),
                setArrImage25(Array.from({ length: 25 }, () => false)))
              : ((menuSelected === "Inmuebles" &&
                  subMenuSelected !== "Galería" &&
                  subMenuSelected !== "") ||
                  (menuSelected === "Amenidades" &&
                    subMenuSelected !== "Galería" &&
                    subMenuSelected !== "")) &&
                imageUrls.length === 25
              ? (setArrImage25([...imageDivsTemp]),
                setArrImage100(Array.from({ length: 100 }, () => false)),
                setArrImage50(Array.from({ length: 50 }, () => false)))
              : (setArrImage100([...imageDivsTemp]),
                setArrImage25(Array.from({ length: 25 }, () => false)),
                setArrImage50(Array.from({ length: 50 }, () => false)));
          };
        });
      };

      const preloadImagesSequentially = async () => {
        let fourthPositionCounter = 0;
        for (let i = 0; i < X.length; i++) {
          const x = X[i];
          for (
            let n = 0;
            n <=
            (imageUrls.length > 50
              ? 9
              : imageUrls.length > 25 && imageUrls.length < 51
              ? 4
              : 2);
            n++
          ) {
            const value = x + n * 10;
            if (imageUrls.length < 26 && value >= 25) {
              break;
            }

            const src =
              (window.hybrid
                ? ""
                : "https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/") +
              imageUrls[value].replace(/ /g, "%20");
            await loadImage(src, value); // Espera hasta que la imagen actual se haya cargado
            if (i === 3) {
              // i === 3 es la cuarta posición de X
              fourthPositionCounter++;
              setTimeout(() => {
                setIsLoading(false);
              }, 1000);
            }
          }
        }
      };

      preloadImagesSequentially();
    }
  }, [imageUrls]);

  useEffect(() => {
    setScreenWidth(window.innerWidth);
    setScreenHeight(window.innerHeight);
  }, [screenWidth]);

  useEffect(() => {
    if (Object.keys(currentSelectedAttribute).length > 0) {
      /* const generalFrame = attributesFrame?.find(
        (e: any) =>
          e.value === currentSelectedAttribute?.id && e.type === "GENERAL"
      )?.frame;

      const detailFrame = attributesFrame?.find(
        (e: any) =>
          e.value === currentSelectedAttribute?.id &&
          e.type === "DETAIL" &&
          e.hierarchical ===
            attributesValues
              .find((o: any) => o.id === e.attribute)
              .values.find(
                (u: any) => u.value.replace(/\s+/g, "") === subMenuSelected
              )?.id
      )?.frame;
      if(generalFrame !== undefined || detailFrame !== undefined) { */
      setCurrentImageIndex(frame - 1);
      setchangeAtribute(currentSelectedAttribute);
      setFrame(frame);
      //}
    }
  }, [currentSelectedAttribute]);

  useEffect(() => {
    if (isSelectedAmenities !== "") {
      setCurrentImageIndex(
        menuSelected === "Amenidades" &&
          subMenuSelected !== "" &&
          subMenuSelected !== "Galería" &&
          frame > 25 &&
          frame <= 50 &&
          imageUrls.length === 25
          ? Math.round(frame / 2 - 1)
          : menuSelected === "Amenidades" &&
            subMenuSelected !== "" &&
            subMenuSelected !== "Galería" &&
            frame > 50
          ? Math.round(frame / 4 - 1)
          : frame - 1
      );
      setchangeAmenities(isSelectedAmenities);
      setFrame(
        menuSelected === "Amenidades" &&
          subMenuSelected !== "" &&
          subMenuSelected !== "Galería" &&
          frame > 25 &&
          frame <= 50 &&
          imageUrls.length === 25
          ? Math.round(frame / 2)
          : menuSelected === "Amenidades" &&
            subMenuSelected !== "" &&
            subMenuSelected !== "Galería" &&
            frame > 50
          ? Math.round(frame / 4)
          : frame
      );
    }
  }, [isSelectedAmenities]);

  const prevMenuSelectedRef: any = React.useRef();

  useEffect(() => {
    // Accede al estado anterior de menuSelected
    const prevMenuSelected = prevMenuSelectedRef.current;

    setCurrentImageIndex(
      /* (menuSelected === "Urbanismo" ||
        (menuSelected === "Inmuebles" &&
          subMenuSelected !== "" &&
          subMenuSelected !== "Galería")) &&
        frame > 50
        ? Math.round(frame / 2 - 1)
        : menuSelected === "Amenidades" &&
          subMenuSelected !== "" &&
          subMenuSelected !== "Galería" &&
          frame > 25 &&
          frame <= 50 &&
          imageUrls.length === 25
        ? Math.round(frame / 2 - 1)
        : menuSelected === "Amenidades" &&
          subMenuSelected !== "" &&
          subMenuSelected !== "Galería" &&
          frame > 50
        ? Math.round(frame / 4 - 1)
        :  */ frame - 1
    );
    setFrame(
      /* (menuSelected === "Urbanismo" ||
        (menuSelected === "Inmuebles" &&
          subMenuSelected !== "" &&
          subMenuSelected !== "Galería")) &&
        frame > 50
        ? Math.round(frame / 2)
        : menuSelected === "Amenidades" &&
          subMenuSelected !== "" &&
          subMenuSelected !== "Galería" &&
          frame > 25 &&
          frame <= 50 &&
          imageUrls.length === 25
        ? Math.round(frame / 2)
        : menuSelected === "Amenidades" &&
          subMenuSelected !== "" &&
          subMenuSelected !== "Galería" &&
          frame > 50
        ? Math.round(frame / 4)
        :  */ frame
    );
    setchangeAmenities(isSelectedAmenities);

    // Guarda el valor actual de menuSelected en el ref para la próxima renderización
    prevMenuSelectedRef.current = menuSelected;
  }, [menuSelected, subMenuSelected, imageUrls]);

  useEffect(() => {
    setIShowAsoleacion(false);

    if (Object.keys(isView).length > 0) {
      setCurrentImageIndex(frame - 1);
      const targetIndex = frame - 1;
      const start = performance.now();
      const duration = 1000; // Duración de la animación en milisegundos

      const animate = (timestamp) => {
        const elapsed = timestamp - start;
        const progress = Math.min(elapsed / duration, 1); // Limita el progreso a 1 para asegurarnos de que la animación termine
        const easedProgress = easeInOutQuad(progress); // Aplica una función de easing para suavizar la animación

        // Calcula la posición intermedia entre la imagen actual y la imagen de destino
        const interpolatedIndex = Math.round(
          currentImageIndex + (targetIndex - currentImageIndex) * easedProgress
        );

        setCurrentImageIndex(interpolatedIndex);

        if (progress < 1) {
          // Sigue animando si no hemos alcanzado el final de la animación
          requestAnimationFrame(animate);
        } else {
          setFrame(frame); // Una vez finalizada la animación, actualiza el frame
          setTimeout(() => {
            setIShowAsoleacion(true);
          }, 100);
        }
      };

      // Comienza la animación
      requestAnimationFrame(animate);
    }
  }, [isView]);

  useEffect(() => {
    const targetIndex = frame - 1;
    const start = performance.now();
    const duration = 1000; // Duración de la animación en milisegundos

    const animate = (timestamp) => {
      const elapsed = timestamp - start;
      const progress = Math.min(elapsed / duration, 1); // Limita el progreso a 1 para asegurarnos de que la animación termine
      const easedProgress = easeInOutQuad(progress); // Aplica una función de easing para suavizar la animación

      // Calcula la posición intermedia entre la imagen actual y la imagen de destino
      const interpolatedIndex = Math.round(
        currentImageIndex + (targetIndex - currentImageIndex) * easedProgress
      );

      setCurrentImageIndex(interpolatedIndex);

      if (progress < 1) {
        // Sigue animando si no hemos alcanzado el final de la animación
        requestAnimationFrame(animate);
      } else {
        setFrame(frame); // Una vez finalizada la animación, actualiza el frame
      }
    };

    // Comienza la animación
    requestAnimationFrame(animate);
  }, [changeAttribute]);

  useEffect(() => {
    const targetIndex =
      menuSelected === "Amenidades" &&
      subMenuSelected !== "" &&
      subMenuSelected !== "Galería" &&
      frame > 25 &&
      frame <= 50 &&
      imageUrls.length === 25
        ? Math.round(frame / 2 - 1)
        : menuSelected === "Amenidades" &&
          subMenuSelected !== "" &&
          subMenuSelected !== "Galería" &&
          frame > 50
        ? Math.round(frame / 4 - 1)
        : frame - 1;
    const start = performance.now();
    const duration = 1000; // Duración de la animación en milisegundos

    const animate = (timestamp) => {
      const elapsed = timestamp - start;
      const progress = Math.min(elapsed / duration, 1); // Limita el progreso a 1 para asegurarnos de que la animación termine
      const easedProgress = easeInOutQuad(progress); // Aplica una función de easing para suavizar la animación

      // Calcula la posición intermedia entre la imagen actual y la imagen de destino
      const interpolatedIndex = Math.round(
        currentImageIndex + (targetIndex - currentImageIndex) * easedProgress
      );

      setCurrentImageIndex(interpolatedIndex);

      if (progress < 1) {
        // Sigue animando si no hemos alcanzado el final de la animación
        requestAnimationFrame(animate);
      } else {
        setFrame(
          menuSelected === "Amenidades" &&
            subMenuSelected !== "" &&
            subMenuSelected !== "Galería" &&
            frame > 25 &&
            frame <= 50 &&
            imageUrls.length === 25
            ? Math.round(frame / 2)
            : menuSelected === "Amenidades" &&
              subMenuSelected !== "" &&
              subMenuSelected !== "Galería" &&
              frame > 50
            ? Math.round(frame / 4)
            : frame
        ); // Una vez finalizada la animación, actualiza el frame
      }
    };

    // Comienza la animación
    requestAnimationFrame(animate);
  }, [changeAmenities]);

  // Función de easing para suavizar la animación
  const easeInOutQuad = (t) => {
    return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
  };

  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      if (dragStart !== null) {
        const movementX = e.clientX - dragStart.x;
        // Aplicar un filtro de paso bajo al movimiento del ratón
        setSmoothedMovementX(smoothedMovementX * 0.9 + movementX * 0.1);
        setDragStart({ x: e.clientX });
      }
    };
    const handleTouchMove = (e: TouchEvent) => {
      if (dragStart !== null) {
        const movementX = e.touches[0].clientX - dragStart.x;
        // Aplicar un filtro de paso bajo al movimiento del ratón
        setSmoothedMovementX(smoothedMovementX * 2 + movementX * 0.1);
        setDragStart({ x: e.touches[0].clientX });
      }
    };

    const handleMouseUp = () => {
      setDragStart(null);
    };

    const handleTouchUp = () => {
      setDragStart(null);
    };

    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);

    document.addEventListener("touchmove", handleTouchMove);
    document.addEventListener("touchend", handleTouchUp);

    return () => {
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", handleMouseUp);

      document.removeEventListener("touchmove", handleTouchMove);
      document.removeEventListener("touchend", handleTouchUp);
    };
  }, [dragStart, smoothedMovementX]);

  const loadImageGeneral = (src: string, value: number): Promise<void> => {
    return new Promise((resolve) => {
      const image = new Image();
      let imageDivsTemp: any =
        menuSelected === "Urbanismo" ||
        (((menuSelected === "Inmuebles" &&
          subMenuSelected !== "Galería" &&
          subMenuSelected !== "") ||
          (menuSelected === "Amenidades" &&
            subMenuSelected !== "Galería" &&
            subMenuSelected !== "")) &&
          imageUrls.length === 50)
          ? arrImage50
          : ((menuSelected === "Inmuebles" &&
              subMenuSelected !== "Galería" &&
              subMenuSelected !== "") ||
              (menuSelected === "Amenidades" &&
                subMenuSelected !== "Galería" &&
                subMenuSelected !== "")) &&
            imageUrls.length === 25
          ? arrImage25
          : arrImage100;

      image.src = src;
      image.onload = () => {
        resolve();
        imageDivsTemp[value] = true;
        menuSelected === "Urbanismo" ||
        (((menuSelected === "Inmuebles" &&
          subMenuSelected !== "Galería" &&
          subMenuSelected !== "") ||
          (menuSelected === "Amenidades" &&
            subMenuSelected !== "Galería" &&
            subMenuSelected !== "")) &&
          imageUrls.length === 50)
          ? (setArrImage50([...imageDivsTemp]),
            setArrImage100(Array.from({ length: 100 }, () => false)),
            setArrImage25(Array.from({ length: 25 }, () => false)))
          : ((menuSelected === "Inmuebles" &&
              subMenuSelected !== "Galería" &&
              subMenuSelected !== "") ||
              (menuSelected === "Amenidades" &&
                subMenuSelected !== "Galería" &&
                subMenuSelected !== "")) &&
            imageUrls.length === 25
          ? (setArrImage25([...imageDivsTemp]),
            setArrImage100(Array.from({ length: 100 }, () => false)),
            setArrImage50(Array.from({ length: 50 }, () => false)))
          : (setArrImage100([...imageDivsTemp]),
            setArrImage25(Array.from({ length: 25 }, () => false)),
            setArrImage50(Array.from({ length: 50 }, () => false)));
      };
    });
  };

  const handleTouchDown = (e: React.TouchEvent<HTMLDivElement>) => {
    setDragStart({ x: e.touches[0].clientX });
  };

  const handleMouseDown = (e: React.MouseEvent<HTMLDivElement>) => {
    setDragStart({ x: e.clientX });
  };

  const handleMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
    if (dragStart !== null) {
      const movementX = e.clientX - dragStart.x;
      const containerWidth = containerRef.current?.offsetWidth || 0;
      const imagesCount = imageUrls?.length;

      let imagesToRotate = Math.floor(
        Math.abs(movementX) * imagesToRotateMultiplier
      );

      if (imagesToRotate < 1) {
        imagesToRotate = 1;
      }

      let newIndex = currentImageIndex - Math.sign(movementX) * imagesToRotate;

      //console.log(imagesCount);

      if (imagesCount === 25) {
        if (newIndex < 0) {
          newIndex = 0; // Si es menor que 0, ajusta a 0.
        } else if (newIndex >= 25) {
          newIndex = 24; // Si es mayor o igual a 25, ajusta a 24.
        } else {
          newIndex %= 25; // Mantén newIndex dentro del rango 0-24.
        }
      } else {
        if (newIndex < 0) {
          newIndex = imagesCount + (newIndex % imagesCount);
        } else {
          newIndex %= imagesCount;
        }
      }

      // Validar newIndex en arrImage[arrImage]
      let originalIndex = newIndex;
      const direction = Math.sign(movementX);

      //console.log(menuSelected === "Urbanismo" || (menuSelected === "Inmuebles" && subMenuSelected !== "Spin" && subMenuSelected !== "" ) ? arrImage50 : menuSelected !== "Urbanismo" && menuSelected !== "Ubicación" && menuSelected !== "Galería" ? arrImage100 : arrImage25);
      /* console.log(menuSelected === "Urbanismo" ||
        (((menuSelected === "Inmuebles" &&
          subMenuSelected !== "Galería" &&
          subMenuSelected !== "") ||
          (menuSelected === "Amenidades" &&
            subMenuSelected !== "Galería" &&
            subMenuSelected !== "")) &&
          imageUrls.length === 50)
          ? !arrImage50[newIndex]
          : ((menuSelected === "Inmuebles" &&
              subMenuSelected !== "Galería" &&
              subMenuSelected !== "") ||
              (menuSelected === "Amenidades" &&
                subMenuSelected !== "Galería" &&
                subMenuSelected !== "")) &&
            imageUrls.length === 25
          ? !arrImage25[newIndex]
          : !arrImage100[newIndex]); */

      while (
        menuSelected === "Urbanismo" ||
        (menuSelected === "Inmuebles" &&
          subMenuSelected !== "Galería" &&
          subMenuSelected !== "") ||
        (menuSelected === "Amenidades" &&
          subMenuSelected !== "Galería" &&
          subMenuSelected !== "" &&
          imageUrls.length === 50)
          ? !arrImage50[newIndex]
          : /* (menuSelected === "Inmuebles" &&
              subMenuSelected !== "Galería" &&
              subMenuSelected !== "") || */
          menuSelected === "Amenidades" &&
            subMenuSelected !== "Galería" &&
            subMenuSelected !== "" &&
            imageUrls.length === 25
          ? !arrImage25[newIndex]
          : !arrImage100[newIndex]
      ) {
        //console.log("aqui");

        if (direction < 0) {
          //console.log("Aqui", direction);
          newIndex = (newIndex + 1) % imagesCount;
        } else if (direction > 0) {
          //console.log("Aca", direction);
          newIndex = (newIndex - 1) % imagesCount;
        }
        if (newIndex === originalIndex) {
          // Si hemos recorrido todo el array y no encontramos un true, salimos
          break;
        }
      }

      setCurrentImageIndex(newIndex);
      setFrame(newIndex + 1);
    }
  };

  const handleTouchMove = (e: React.TouchEvent<HTMLDivElement>) => {
    if (dragStart !== null && e.touches.length > 0) {
      const touch = e.touches[0];
      const movementX = touch.clientX - dragStart.x;
      const containerWidth = containerRef.current?.offsetWidth || 0;
      const imagesCount = imageUrls?.length;

      let imagesToRotate = Math.floor(
        Math.abs(movementX) * imagesToRotateMultiplier
      );

      if (imagesToRotate < 1) {
        imagesToRotate = 1;
      }

      let newIndex = currentImageIndex - Math.sign(movementX) * imagesToRotate;

      if (imagesCount === 25) {
        if (newIndex < 0) {
          newIndex = 0;
        } else if (newIndex >= 25) {
          newIndex = 24;
        } else {
          newIndex %= 25;
        }
      } else {
        if (newIndex < 0) {
          newIndex = imagesCount + (newIndex % imagesCount);
        } else {
          newIndex %= imagesCount;
        }
      }

      let originalIndex = newIndex;
      const direction = Math.sign(movementX);

      while (
        menuSelected === "Urbanismo" ||
        (menuSelected === "Inmuebles" &&
          subMenuSelected !== "Galería" &&
          subMenuSelected !== "") ||
        (menuSelected === "Amenidades" &&
          subMenuSelected !== "Galería" &&
          subMenuSelected !== "" &&
          imageUrls.length === 50)
          ? !arrImage50[newIndex]
          : /* (menuSelected === "Inmuebles" &&
              subMenuSelected !== "Galería" &&
              subMenuSelected !== "") || */
          menuSelected === "Amenidades" &&
            subMenuSelected !== "Galería" &&
            subMenuSelected !== "" &&
            imageUrls.length === 25
          ? !arrImage25[newIndex]
          : !arrImage100[newIndex]
      ) {
        if (direction < 0) {
          newIndex = (newIndex + 1) % imagesCount;
        } else if (direction > 0) {
          newIndex = (newIndex - 1) % imagesCount;
        }
        if (newIndex === originalIndex) {
          break;
        }
      }

      setCurrentImageIndex(newIndex);
      setFrame(newIndex + 1);
    }
  };

  const handleMouseUp = () => {
    setDragStart(null);
  };

  const handleTouchUp = () => {
    setDragStart(null);
  };

  return isLoading ? (
    <LoadingSpinner logo="./UI/menu/urbanismo.svg" isLoading={true} />
  ) : (
    <div
      className="spin-container"
      ref={containerRef}
      onTouchStart={handleTouchDown}
      onMouseDown={handleMouseDown}
      onMouseMove={handleMouseMove}
      onTouchMove={handleTouchMove}
      onMouseUp={handleMouseUp}
      onTouchEnd={handleTouchUp}
      onMouseLeave={handleMouseUp}
      style={{
        display: isShowAsoleacion ? "none" : "initial",
        cursor: "grab",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {imageUrls?.map((imageUrl, index) => {
        if (
          menuSelected === "Urbanismo" ||
          (menuSelected === "Inmuebles" &&
            subMenuSelected !== "Galería" &&
            subMenuSelected !== "") ||
          (menuSelected === "Amenidades" &&
            subMenuSelected !== "Galería" &&
            subMenuSelected !== "" &&
            imageUrls.length === 50)
            ? !arrImage50[index]
            : /* (menuSelected === "Inmuebles" &&
                subMenuSelected !== "Galería" &&
                subMenuSelected !== "") || */
            menuSelected === "Amenidades" &&
              subMenuSelected !== "Galería" &&
              subMenuSelected !== "" &&
              imageUrls.length === 25
            ? !arrImage25[index]
            : !arrImage100[index]
        ) {
          return null;
        }

        return (
          <div
            key={index}
            data-tsx={imageUrl}
            style={{
              backgroundImage: `url(${
                window.hybrid
                  ? ""
                  : "https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/"
              }${imageUrl.replace(/ /g, "%20")})`,
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              width: "100%",
              height: "100%",
              visibility: index === currentImageIndex ? "visible" : "hidden",
              position: index === currentImageIndex ? "initial" : "absolute",
              backgroundPosition: "center 50%",
              top: 0,
              left: 0,
            }}
          />
        );
      })}
    </div>
  );
};

export default SpinGeneralContainer;
